<template>
  <div>
    <li class="xxl-news-item single-pic">
      <a :href="data.url" target="_blank" class="news-link">
        <div class="news-img">
          <div
              class="news-img-bg hover-scale"
              :data-src="data.pic"
              lazy="loaded"
              :style="'background-image: url(' + data.pic + ')'"
          ></div>
        </div>
        <div class="news-right">
          <div class="news-title">
            {{ data.title }}
          </div>
          <div class="news-desc">
            {{ data.subTitle }}
          </div>
          <div class="news-info">
            <span>{{ data.category }}</span><span>{{ data.source }}</span><span>{{ timeToString(data.create_time) }}</span>
          </div>
        </div>
      </a>
    </li>
    <li class="xxl-news-item single-pic" v-if="index !== 0 && index%4 === 0">
      <div :class="'_vdx2oe1phck_' + index" style="width: 620px;"></div>
    </li>
  </div>

</template>

<script>
import { timeToString } from "@/utils"

export default {
  name: "InfoFlowItems",
  props: ['data','index'],
  data() {
    return {

    };
  },
  methods: {
    timeToString,
  },
  mounted() {
    let self = this;
    // ////console.log(this.index%4 === 0)
    (window.slotbydup = window.slotbydup || []).push({
        id: "u7015039",
        container: '_vdx2oe1phck_' + self.index,
        async: true
    });
  }
};
</script>

<style>
</style>
